module.exports = __webpack_public_path__ + "static/fonts/PingFangMedium.15974853.ttf";